"use client";
import { jsx } from "react/jsx-runtime";
import { usePolymorphic } from "../../../hooks/usePolymorphic.js";
import { sharedHandler } from "../../../shared/sharedHandler/sharedHandler.js";
import { Box } from "@mantine/core";
import { forwardRef } from "react";
import '../../../assets/Link.css';const root = "_root_8ej6r_2";
const LinkStyles = {
  root
};
const _Link = forwardRef((props, ref) => {
  const { children, polymorphicProps, className, disablePolymorphic, style, ...rest } = props;
  const { link: PolymorphicLink } = usePolymorphic();
  return /* @__PURE__ */ jsx(
    Box,
    {
      ...rest,
      ...disablePolymorphic ? {} : PolymorphicLink && polymorphicProps,
      component: disablePolymorphic ? "a" : PolymorphicLink || "a",
      ref,
      className: `${LinkStyles.root} ${className}`,
      style,
      children
    }
  );
});
_Link.displayName = "Link";
const Link = sharedHandler(_Link);
Link.displayName = _Link.displayName;
export {
  LinkStyles as L,
  Link as default
};
